import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
// import { CartitemAtom } from "../../recoil/cart";
import { getRecoil, setRecoil } from "recoil-nexus";
import ConfirmModal from "../../components/modal/ConfirmModal";
import CustomerInfoModal from "../../components/modal/CustomerInfoModal";
import PaymentListModal from "../../components/modal/PaymentListModal";
import RoomNumberModal from "../../components/modal/RoomNumberModal";
import SpeechBubble from "../../components/SpeechBubble";
import ApiController from "../../controller/ApiController";
import LogController from "../../controller/LogController";
import { EventType } from "../../controller/MasterController";
import MessageController from "../../controller/MessageController";
import OrderController, {
  StoreOrderType,
} from "../../controller/OrderController";
import {
  Coupons,
  DiscountType,
  storeType,
} from "../../controller/StoreController";
import { useToast } from "../../controller/ToastController";
import { authState, masterStoreState } from "../../recoil/auth";
import {
  cartPayInfoState,
  cartProductQuantityState,
  cartState,
} from "../../recoil/cart";
import { eventState } from "../../recoil/event";
import { langState, langText, langTextBestDiscount } from "../../recoil/lang";
import { settingsState } from "../../recoil/settings";
import {
  CouponType,
  orderDetailOptionType,
  orderDetailRealmType,
  PRODUCT_TYPE_DELIVERY,
} from "../../recoil/type";
import {
  getAvailableCoupons,
  getBestDiscount,
  getOptionName,
  getProductName,
} from "../../utils/util";

const Cart = (oProps: {
  storeInfo: storeType | undefined;
  coupons: Coupons[] | undefined;
  resetTimer: any;
  onClickOrder?: () => {};
}) => {
  const settings = useRecoilValue(settingsState);
  const currentEventState = useRecoilValue(eventState);
  const kioskMode = settings.view.kioskmode.value === "1";
  const cart = useRecoilValue(cartState);
  const cartQuantitiy = useRecoilValue(cartProductQuantityState);
  const cartPay = useRecoilValue(cartPayInfoState);
  const [isOptionModalVisible, setIsOptionModalVisible] =
    useState<boolean>(false);
  const [lang, setLang] = useRecoilState<number>(langState);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  //실제 사용가능 쿠폰
  const [couponList, setCouponList] = useState<CouponType[]>([]);

  //고객에게 보여지는 쿠폰
  const [visibleCouponList, setVisibleCouponList] = useState<CouponType[]>([]);

  //고객에게 보여지는 쿠폰
  const [unavailableCouponList, setUnavailableCouponList] = useState<
    CouponType[]
  >([]);
  const [visibleClosed, setVisibleClosed] = useState<boolean>(false);
  const [visibleCustomerInfoModal, setVisibleCustomerInfoModal] =
    useState<boolean>(false);
  const [visibleRoomNumberModal, setVisibleRoomNumberModal] =
    useState<boolean>(false);
  const [areaName, setAreaName] = useState<string>("");
  const [roomName, setRoomName] = useState<string>("");
  const [kioskAreaNumber, setKioskAreaNumber] = useState<number>(-1);
  const [kioskRoomNumber, setKioskRoomNumber] = useState<number>(-1);

  const [weatherNotice, setWeatherNotice] = useState<string>("");

  const [orderInfo, setOrderInfo] = useState<StoreOrderType>({
    address1: "",
    address2: "",
    area_number: 0,
    number: 0,
    area_name: "",
    name: "",
    store_id: 0,
    limit_order_price: 0,
    max_delivery_distance: "",
    base_delivery_price: 0,
    base_delivery_distance: "",
    surcharge_delivery_distance: 0,
    surcharge_delivery_price: 0,
    is_self_delivery: 0,
    delivery_call_type: 0,
    delivery_estimated_time: 0,
    delivery_prepare_time: 0,
    pickup_name: "",
    pickup_name_en: "",
    store_login_yn: true,
    next_open_time: "",
    next_close_time: "",
    store_availability_yn: true,
    store_availability: "",
    room_tip: 0,
    coupon_list: {
      availble_coupon_list: [],
      unavailable_coupon_list: [],
    },
  });

  const [discount, setDiscount] = useState<DiscountType>({
    discountAmount: 0,
    hqDiscountAmount: 0,
    storeDiscountAmount: 0,
    storeDiscountList: [],
    hqDiscountList: [],
    couponList: [],
  });

  const [realPayPrice, setRealPayPrice] = useState<number>(
    cart.length > 0 && cart[0].product_type === PRODUCT_TYPE_DELIVERY
      ? cartPay.total_amount_incl -
          discount.discountAmount +
          orderInfo.base_delivery_price +
          orderInfo.room_tip
      : cartPay.total_amount_incl - discount.discountAmount
  );

  const [number, setNumber] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [paymentReady, setPaymentReady] = useState<boolean>(false);

  const [visiblePaymentDelay, setVisiblePaymentDelay] =
    useState<boolean>(false);

  const showToast = useToast();

  const bestDiscount = getBestDiscount(
    cartPay.total_amount_incl,
    oProps.storeInfo ? oProps.storeInfo.base_delivery_price : 0,
    oProps.storeInfo ? oProps.storeInfo.delivery_price : [],
    getAvailableCoupons(cartPay.total_amount_incl, oProps.coupons || [])
      .availableCouponList,
    getAvailableCoupons(cartPay.total_amount_incl, oProps.coupons || [])
      .unavailableCouponList
  );

  console.log("bestDiscount", bestDiscount);

  const checkVisibleSpeechBubble = () => {
    const deliveryPriceCheck = oProps.storeInfo
      ? oProps.storeInfo.delivery_price.filter(
          (item) => cartPay.total_amount_incl < item.more_order_price
        )
      : [];

    const couponListCheck = getAvailableCoupons(
      cartPay.total_amount_incl,
      oProps.coupons || []
    );

    console.log(
      "couponListCheck.unavailableCouponList",
      couponListCheck.unavailableCouponList,
      deliveryPriceCheck
    );

    return (
      bestDiscount.discount !== 0 &&
      bestDiscount.required !== 0 &&
      (couponListCheck.unavailableCouponList.length !== 0 ||
        deliveryPriceCheck.length !== 0)
    );
  };

  const doPayment = async () => {
    try {
      LogController.click({
        path: "CartInfo",
        params: "click",
        params2: "결제하기 클릭",
      });
      if (kioskMode) {
        setOrderInfo((prevOrderInfo) => ({
          ...prevOrderInfo,
          area_number: kioskAreaNumber,
          number: kioskRoomNumber,
          area_name: areaName,
          name: roomName,
        }));
      }
    } catch (err) {
      console.log(err);
    }

    try {
      const requestPayment = await ApiController.payment.request({});
      if (requestPayment.data.data.success) {
        let message = MessageController.getPayApprovalRequestData(
          realPayPrice,
          cart[0].store_id,
          requestPayment.data.data.payment_request_id
        );
        window.ReactNativeWebView?.postMessage(message);
      } else {
        // showToast("에러메시지");
      }
    } catch (err) {
      // showToast("에러메시지");
      console.log(err);
    }
  };

  // React.useEffect(()=>{
  //   console.log("isOptionModalVisible:", isOptionModalVisible);
  // },[isOptionModalVisible]);

  useEffect(() => {
    console.log("cart", cart);
  }, []);

  useEffect(() => {
    getWeatherList();
  }, [lang]);

  // 쿠폰 로직
  React.useEffect(() => {
    let hqList: { description: string; discount: number }[] = [];
    let storeList: { description: string; discount: number }[] = [];
    let discount = 0;
    let storeDiscount = 0;
    let hqDiscount = 0;
    const price = cartPay.total_amount_incl;
    let totalPrice = cartPay.total_amount_incl;
    let applyCoupons: (CouponType & {
      store_discount_amount: number;
      com_discount_amount: number;
    })[] = [];
    for (let coupon of couponList) {
      let com_discount_amount = 0;
      let store_discount_amount = 0;
      if (coupon.coupon_type === 0) {
        //정액할인

        //매장부담
        if (coupon.partner_discount > 0) {
          if (totalPrice - coupon.partner_discount <= 0) {
            storeList.push({
              description: coupon.coupon_name + " 할인",
              discount: totalPrice,
            });
            discount += totalPrice;
            storeDiscount += totalPrice;
            store_discount_amount += totalPrice;
            totalPrice = 0;
            applyCoupons.push({
              ...coupon,
              com_discount_amount,
              store_discount_amount,
            });
            break;
          } else {
            storeList.push({
              description: coupon.coupon_name + " 할인",
              discount: coupon.partner_discount,
            });
            discount += coupon.partner_discount;
            storeDiscount += coupon.partner_discount;
            store_discount_amount += coupon.partner_discount;
            totalPrice -= coupon.partner_discount;
          }
        }
        //본사부담
        if (coupon.hq_discount > 0) {
          if (totalPrice - coupon.hq_discount <= 0) {
            hqList.push({
              description: coupon.coupon_name + " 할인",
              discount: totalPrice,
            });
            discount += totalPrice;
            hqDiscount += totalPrice;
            com_discount_amount += totalPrice;
            applyCoupons.push({
              ...coupon,
              com_discount_amount,
              store_discount_amount,
            });
            totalPrice = 0;
            break;
          } else {
            hqList.push({
              description: coupon.coupon_name + " 할인",
              discount: coupon.hq_discount,
            });
            discount += coupon.hq_discount;
            hqDiscount += coupon.hq_discount;
            com_discount_amount += coupon.hq_discount;
            totalPrice -= coupon.hq_discount;
          }
        }
      } else if (coupon.coupon_type === 1) {
        //정률할인

        //할인금액
        let priceDc = Math.floor((price * coupon.percent) / 100);

        //할인금액이 최대할인금액 보다 클경우 조정.
        if (priceDc > coupon.max_discount) {
          priceDc = coupon.max_discount;
        }

        //사장님 부담 할인금액
        const partnerDc = Math.floor((priceDc * coupon.partner_percent) / 100);
        //본사부담 할인금액
        const hqDc = priceDc - partnerDc;

        if (partnerDc > 0) {
          if (totalPrice - partnerDc <= 0) {
            storeList.push({
              description: coupon.coupon_name + " 할인",
              discount: totalPrice,
            });
            discount += totalPrice;
            storeDiscount += totalPrice;
            store_discount_amount += totalPrice;
            totalPrice = 0;
            applyCoupons.push({
              ...coupon,
              com_discount_amount,
              store_discount_amount,
            });
            break;
          } else {
            storeList.push({
              description: coupon.coupon_name + " 할인",
              discount: partnerDc,
            });
            discount += partnerDc;
            storeDiscount += partnerDc;
            store_discount_amount += partnerDc;
            totalPrice -= partnerDc;
          }
        }

        if (hqDc > 0) {
          if (totalPrice - hqDc <= 0) {
            hqList.push({
              description: coupon.coupon_name + " 할인",
              discount: totalPrice,
            });
            discount += totalPrice;
            hqDiscount += totalPrice;
            totalPrice -= totalPrice;
            com_discount_amount += totalPrice;
            applyCoupons.push({
              ...coupon,
              com_discount_amount,
              store_discount_amount,
            });
            break;
          } else {
            hqList.push({
              description: coupon.coupon_name + " 할인",
              discount: hqDc,
            });
            discount += hqDc;
            hqDiscount += hqDc;
            totalPrice -= hqDc;
            com_discount_amount += hqDc;
          }
        }
      } else if (coupon.coupon_type === 2) {
        if (coupon.price > 0) {
          //정액할인
          if (coupon.partner_discount > 0) {
            if (totalPrice - coupon.partner_discount <= 0) {
              storeList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: totalPrice,
              });
              discount += totalPrice;
              storeDiscount += totalPrice;
              store_discount_amount += totalPrice;
              totalPrice = 0;
              applyCoupons.push({
                ...coupon,
                com_discount_amount,
                store_discount_amount,
              });
              break;
            } else {
              storeList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: coupon.partner_discount,
              });
              discount += coupon.partner_discount;
              storeDiscount += coupon.partner_discount;
              store_discount_amount += coupon.partner_discount;
              totalPrice -= coupon.partner_discount;
            }
          }
          //본사부담
          if (coupon.hq_discount > 0) {
            if (totalPrice - coupon.hq_discount <= 0) {
              hqList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: totalPrice,
              });
              discount += totalPrice;
              hqDiscount += totalPrice;
              com_discount_amount += totalPrice;
              applyCoupons.push({
                ...coupon,
                com_discount_amount,
                store_discount_amount,
              });
              totalPrice = 0;
              break;
            } else {
              hqList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: coupon.hq_discount,
              });
              discount += coupon.hq_discount;
              hqDiscount += coupon.hq_discount;
              com_discount_amount += coupon.hq_discount;
              totalPrice -= coupon.hq_discount;
            }
          }
        } else if (coupon.percent > 0) {
          //정률할인
          //할인금액
          let priceDc = Math.floor((price * coupon.percent) / 100);

          //할인금액이 최대할인금액 보다 클경우 조정.
          if (priceDc > coupon.max_discount) {
            priceDc = coupon.max_discount;
          }

          //사장님 부담 할인금액
          const partnerDc = Math.floor(
            (priceDc * coupon.partner_percent) / 100
          );
          //본사부담 할인금액
          const hqDc = priceDc - partnerDc;

          if (partnerDc > 0) {
            if (totalPrice - partnerDc <= 0) {
              storeList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: totalPrice,
              });
              discount += totalPrice;
              storeDiscount += totalPrice;
              store_discount_amount += totalPrice;
              totalPrice = 0;
              applyCoupons.push({
                ...coupon,
                com_discount_amount,
                store_discount_amount,
              });
              break;
            } else {
              storeList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: partnerDc,
              });
              discount += partnerDc;
              storeDiscount += partnerDc;
              store_discount_amount += partnerDc;
              totalPrice -= partnerDc;
            }
          }

          if (hqDc > 0) {
            if (totalPrice - hqDc <= 0) {
              hqList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: totalPrice,
              });
              discount += totalPrice;
              hqDiscount += totalPrice;
              totalPrice -= totalPrice;
              com_discount_amount += totalPrice;
              applyCoupons.push({
                ...coupon,
                com_discount_amount,
                store_discount_amount,
              });
              break;
            } else {
              hqList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: hqDc,
              });
              discount += hqDc;
              hqDiscount += hqDc;
              totalPrice -= hqDc;
              com_discount_amount += hqDc;
            }
          }
        }
      }

      applyCoupons.push({
        ...coupon,
        com_discount_amount,
        store_discount_amount,
      });
    }

    setDiscount({
      discountAmount: discount,
      storeDiscountAmount: storeDiscount,
      hqDiscountAmount: hqDiscount,
      storeDiscountList: storeList,
      hqDiscountList: hqList,
      couponList: applyCoupons,
    });
  }, [couponList]);

  React.useEffect(() => {
    setRealPayPrice(
      cart.length > 0 && cart[0].product_type === PRODUCT_TYPE_DELIVERY
        ? cartPay.total_amount_incl -
            discount.discountAmount +
            orderInfo.base_delivery_price +
            orderInfo.room_tip
        : cartPay.total_amount_incl - discount.discountAmount
    );
  }, [cartPay, discount, orderInfo]);

  const setData = async () => {
    const price = cartPay.total_amount_incl;

    let res = await ApiController.store.getStoreOrderData(
      cart[0]?.store_id,
      getRecoil(masterStoreState)!.store_id,
      getRecoil(authState).user_token_id,
      price
    );

    if (res.ok) {
      const orderData: StoreOrderType = res.data;

      setIsOptionModalVisible(true);
      // showToast(`${orderData.store_availability}`);
      if (!orderData.store_availability_yn) {
        setVisibleClosed(true);
      }
      setOrderInfo(orderData);
      console.log("orderData", orderData, cart);
      if (orderData.coupon_list.availble_coupon_list.length > 0) {
        const couponSet: CouponType[] = [];
        let dupflag1 = true;
        let dupflag2 = true;
        for (const c of orderData.coupon_list.availble_coupon_list) {
          if (dupflag1 && c.duplicate_user === 1) {
            couponSet.push(c);
            dupflag1 = false;
          } else if (dupflag2 && c.duplicate_user === 2) {
            couponSet.push(c);
            dupflag2 = false;
          } else if (c.duplicate_user === 0) {
            couponSet.push(c);
          }
        }
        setCouponList(couponSet);
        setVisibleCouponList([...orderData.coupon_list.availble_coupon_list]);
      } else {
        setCouponList([]);
        setVisibleCouponList([]);
      }

      setUnavailableCouponList([
        ...orderData.coupon_list.unavailable_coupon_list,
      ]);
    }
  };

  const getWeatherList = async () => {
    if (oProps.storeInfo) {
      const oParams = {
        user_id: getRecoil(authState).user_id,
        lang: lang,
      };

      const oRes = await ApiController.notice.getWeatherNoticeList(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        if (oResponse.data && oResponse.data.simple_notices.length > 0) {
          setWeatherNotice(
            oResponse.data.simple_notices[
              Math.floor(Math.random() * oResponse.data.simple_notices.length)
            ]
          );
        }
      }
    }
  };

  const resetButton = async () => {
    if (cart.length > 0) {
      const eventData = await getEventList();
      if (eventData && eventData.used === 0) {
        openEvent(eventData);
      } else {
        setVisibleConfirm(true);
      }
    }
  };
  const openEvent = (eventData: EventType) => {
    setRecoil(eventState, {
      ...eventData,
      visible: true,
      coupon: null,
    });

    LogController.event({
      path: "CartInfo",
      params: "event",
      params2: eventData.event_name + "틀린그림찾기 이벤트 발생",
      index: eventData.event_id,
    });
  };
  const getEventList = async () => {
    const user_id = getRecoil(authState).user_id;
    const user_token_id = getRecoil(authState).user_token_id;

    try {
      const response = await ApiController.store.getEventList(
        user_id,
        user_token_id
      );

      if (response && response.data) {
        const oRes = response.data;
        const eventData = oRes.data.filter(
          (item: EventType) => item.event_type === 2 && item.used === 0
        );
        if (eventData.length > 0) {
          return eventData[Math.floor(Math.random() * eventData.length)];
        } else {
          return null;
        }
      }
    } catch (err) {
      console.log("getAdverList err-->", err);
    }
  };
  useEffect(() => {
    if (
      cart.length > 0 &&
      currentEventState.visible === false &&
      currentEventState.try === false
    ) {
      setVisibleConfirm(true);
    }
  }, [currentEventState]);

  useEffect(() => {
    if (visiblePaymentDelay) {
      LogController.event({
        path: "PaymentDelayModal",
        params: "open",
        params2: "결제모듈 호출 후 네트워크 지연경고알림 팝업창 열림",
      });
    }
  }, [visiblePaymentDelay]);

  return (
    <Style>
      <div className="cartWrap">
        <div className="cartContent">
          {cart.map((item: orderDetailRealmType, index) => (
            <div className="cartItem" key={item.product_id}>
              <div className="menuName">
                <h2>{getProductName(item, lang)}</h2>
                {item.options && item.options.length > 0 && (
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                    width={14}
                    height={14}
                    alt="옵션 화살표"
                  />
                )}
                <h4>
                  {item.options?.map(
                    (option: orderDetailOptionType, index: number) =>
                      `${getOptionName(option, lang)}${
                        index !== item.options!.length - 1 ? ", " : ""
                      }`
                  )}
                </h4>
              </div>
              <div className="menuCount">
                <button
                  onClick={() => {
                    OrderController.updateCartRecoilproductQuantityByIndex(
                      index,
                      false,
                      showToast
                    );
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_minus.svg`}
                    alt="메뉴 수량 빼기"
                    width={"31px"}
                    height={"31px"}
                  />
                </button>
                <h2>{item.product_quantity}</h2>
                <button
                  onClick={() => {
                    OrderController.updateCartRecoilproductQuantityByIndex(
                      index,
                      true,
                      showToast
                    );
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_plus.svg`}
                    alt="메뉴 수량 더하기"
                    width={"31px"}
                    height={"31px"}
                  />
                </button>
              </div>
              <h2 className="menuPrice">
                {item.product_total_amount.toLocaleString()}원
              </h2>
              <button
                className="menuRemove"
                onClick={() => {
                  OrderController.deleteCartRecoilproductQuantityByIndex(index);
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
                  alt="메뉴 삭제"
                  width={"24px"}
                  height={"24px"}
                />
              </button>
            </div>
          ))}
        </div>
        <div className="cartFooter">
          <button className="resetCart" onClick={resetButton}>
            <h3>{langText.cartInto_button_reset[lang]}</h3>
          </button>
          <div className="totalCount">
            <h2>
              {langText.total[lang]} {cartQuantitiy} {langText.count[lang]}
            </h2>
            <h2>{cartPay.total_amount_incl.toLocaleString()}원</h2>
          </div>
          <button
            className="orderButton"
            onClick={
              oProps.onClickOrder
                ? oProps.onClickOrder
                : async () => {
                    try {
                      LogController.click({
                        path: "CartInfo",
                        params: "click",
                        params2: "주문하기 버튼 클릭",
                        index: cart.length > 0 ? cart[0].store_id : 0,
                      });
                    } catch (err) {
                      console.log(err);
                    }

                    if (
                      oProps.storeInfo &&
                      oProps.storeInfo.store_availability_yn === true
                    ) {
                      if (cart.length > 0) {
                        setData();
                      } else {
                        showToast(langText.confirmModal_cart[lang]);
                      }
                    } else {
                      //TODO
                      if (cart.length > 0) {
                        showToast(langText.confirmModal_closed[lang], "error");
                      } else {
                        showToast(langText.confirmModal_cart[lang]);
                      }
                    }
                  }
            }
          >
            <h2>{langText.cartInto_button_order[lang]}</h2>
          </button>
          {checkVisibleSpeechBubble() && (
            <div className="speechBubbleWrap">
              <SpeechBubble
                title={
                  langTextBestDiscount(
                    (
                      bestDiscount.required - cartPay.total_amount_incl
                    ).toLocaleString(),
                    bestDiscount.discount.toLocaleString()
                  )[lang]
                }
              />
            </div>
          )}
        </div>
      </div>
      <PaymentListModal
        modalIsVisible={isOptionModalVisible}
        modalSetVisible={setIsOptionModalVisible}
        resetTimer={oProps.resetTimer}
        couponList={couponList}
        visibleCouponList={visibleCouponList}
        unavailableCouponList={unavailableCouponList}
        visibleClosed={visibleClosed}
        setVisibleClosed={setVisibleClosed}
        setCouponList={setCouponList}
        setVisibleCouponList={setVisibleCouponList}
        setUnavailableCouponList={setUnavailableCouponList}
        setVisibleCustomerInfoModal={setVisibleCustomerInfoModal}
        orderInfo={orderInfo}
        discount={discount}
        realPayPrice={realPayPrice}
        doPayment={doPayment}
        number={number}
        setNumber={setNumber}
        email={email}
        setEmail={setEmail}
        visibleCustomerInfoModal={visibleCustomerInfoModal}
        setVisibleRoomNumberModal={setVisibleRoomNumberModal}
        visibleRoomNumberModal={visibleRoomNumberModal}
        areaNumber={kioskAreaNumber}
        roomNumber={kioskRoomNumber}
        setVisiblePaymentDelay={setVisiblePaymentDelay}
        weatherNotice={weatherNotice}
        paymentReady={paymentReady}
        setPaymentReady={setPaymentReady}
        checkVisibleSpeechBubble={checkVisibleSpeechBubble}
        bestDiscount={bestDiscount}
      />
      <RoomNumberModal
        isVisible={visibleRoomNumberModal}
        setVisible={setVisibleRoomNumberModal}
        storeId={getRecoil(masterStoreState)!.store_id}
        setKioskAreaNumber={setKioskAreaNumber}
        setKioskRoomNumber={setKioskRoomNumber}
        setAreaName={setAreaName}
        setRoomName={setRoomName}
        doPayment={doPayment}
        setPaymentReady={setPaymentReady}
      />
      <CustomerInfoModal
        isVisible={visibleCustomerInfoModal}
        setVisible={setVisibleCustomerInfoModal}
        doPayment={doPayment}
        setNumber={setNumber}
        setEmail={setEmail}
        mainTitle={langText.customer_info_modal_title[lang]}
        subTitle={langText.customer_info_notice[lang]}
        setPaymentReady={setPaymentReady}
      />
      <ConfirmModal
        isVisible={visibleConfirm}
        setVisible={setVisibleConfirm}
        title={langText.confirmModal_cart_reset[lang]}
        confirmText={langText.button_confirm[lang]}
        cancelText={langText.button_cancel[lang]}
        onConfirm={() => {
          OrderController.deleteCart();
          return setVisibleConfirm(false);
        }}
      />
      <ConfirmModal
        isVisible={visiblePaymentDelay}
        setVisible={(visible: boolean) => {
          setVisiblePaymentDelay(visible);
          if (!visible) {
            LogController.event({
              path: "PaymentDelayModal",
              params: "close",
              params2: "결제모듈 호출 후 네트워크 지연경고알림 팝업창 닫힘",
            });
          }
        }}
        title={langText.pay_error_text[lang]}
        confirmText={langText.button_confirm[lang]}
      />
    </Style>
  );
};
export default Cart;

const Style = styled.div`
  .cartWrap {
    height: 100%;
    padding: 10px 22px 14px 22px;
    display: flex;
    flex-direction: column;
  }

  /* 장바구니 내역 */
  .cartContent {
    height: 75vh;
    overflow-y: auto;
    border: 1px solid #555;
    border-radius: 10px;
  }
  .cartItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 30px;
    border-bottom: 1px solid #2e2e2e;

    h2 {
      font-size: 20px;
      font-weight: 300;
    }
    h4 {
      color: #ffffff;
      font-weight: 300;
    }
    button {
      display: flex;
      align-items: center;
    }
  }
  .menuName {
    width: 45%;
    max-width: 45%;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    h2 {
      flex: 1;
      white-space: nowrap;
    }
    h4 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .menuCount {
    flex: 0 0 20%;
    display: flex;
    align-items: center;
    justify-content: center;

    h2 {
      margin: 0 20px;
    }
  }
  .menuPrice {
    flex: 0 0 20%;
    text-align: right;
  }
  .cartItem:last-of-type {
    border-bottom: none;
  }

  /* cartFooter */
  .cartFooter {
    position: relative;
    height: 25vh;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 22px;

    button {
      border-radius: 10px;
    }
    .resetCart {
      padding: 17px 22px;
      border: 1px solid #555;

      h3 {
        color: #a7a7a7;
        font-size: 24px;
        font-weight: 600;
      }
    }
    .totalCount {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 10px;
      padding: 17px 40px;
      background: #2b2b2b;
      border-radius: 10px;
    }
    .orderButton {
      padding: 17px 55px;
      background: #4dd2ae;

      h2 {
        font-size: 24px;
        font-weight: 600;
      }
    }
  }

  .speechBubbleWrap {
    position: absolute;
    top: -60px;
    right: 28%;
  }
`;
